import { render } from "./Plantilla.vue?vue&type=template&id=b642f35e"
import script from "./Plantilla.vue?vue&type=script&lang=js"
export * from "./Plantilla.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__